import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import { formatDigitalLoanMoney } from '../utils/moneyInput';

const NotPreapprovedScreen = ({
  literals,
  summary,
  onModifyTerm,
  onSelectOtherPledge,
  onBack,
}) => (
  <div className='full-screen-container digital-loan-result-screen digital-loan-not-preapproved'>
    <div className='screen-content'>
      <h1 className='digital-loan-phase2__title'>{literals.title}</h1>
      <p className='digital-loan-phase2__body mb-4'>{literals.subtitle}</p>

      <div className='digital-loan-summary-block'>
        <h2 className='digital-loan-summary-block__title'>{literals.loanSection}</h2>
        <p>
          <span className='digital-loan-summary-block__label'>{literals.amountLabel}</span>
          <strong>{formatDigitalLoanMoney(summary?.amount)}</strong>
        </p>
        <p>
          <span className='digital-loan-summary-block__label'>{literals.termLabel}</span>
          <strong>
            {summary?.term}
            {' '}
            {literals.termUnit}
          </strong>
        </p>
        <p>
          <span className='digital-loan-summary-block__label'>{literals.frequencyLabel}</span>
          <strong>{summary?.paymentFrequency}</strong>
        </p>
        <p>
          <span className='digital-loan-summary-block__label'>{literals.paymentDayLabel}</span>
          <strong>{summary?.paymentDay}</strong>
        </p>
      </div>
    </div>
    <div className='screen-actions'>
      <Button text={literals.modifyTerm} onClick={onModifyTerm} />
      <Button text={literals.selectOtherPledge} onClick={onSelectOtherPledge} />
      <Button text={literals.back} type='secondary' onClick={onBack} />
    </div>
  </div>
);

NotPreapprovedScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  summary: PropTypes.shape({
    amount: PropTypes.number,
    term: PropTypes.number,
    paymentFrequency: PropTypes.string,
    paymentDay: PropTypes.string,
  }),
  onModifyTerm: PropTypes.func.isRequired,
  onSelectOtherPledge: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default NotPreapprovedScreen;
